export const REJECTION_REASONS = {
  DOCS_UNCLEAR: "Documents are unclear or unreadable",
  DOCS_EXPIRED: "One or more documents are expired",
  DOCS_MISMATCH: "Document details do not match business info",
  GST_INVALID: "GST number could not be verified",
  PAN_INVALID: "PAN number could not be verified",
  FSSAI_MISSING: "FSSAI licence required but missing",
  TRADE_LICENCE_INVALID: "Trade licence invalid or missing",
  MEDICAL_REG_INVALID: "Medical registration could not be verified",
  ADDRESS_INCOMPLETE: "Address or location info incomplete",
  OTHER: "Other (see note)",
} as const;

export type RejectionReasonKey = keyof typeof REJECTION_REASONS;
